"use strict";

export const navigationConstants = {
  cancel: {
    name: "cancel",
    message: "Cancel selected",
  },
  save: {
    name: "save",
    message: "Save selected",
  },
  previous: {
    name: "previous",
    message: "Previous selected",
  },
  beforeContinue: {
    name: "beforeContinue",
    message: "Before continue",
  },
  beforeSubmit: {
    name: "beforeSubmit",
    message: "Before Submit",
  },
  continue: {
    name: "continue",
    message: "Continue selected",
  },
  submit: {
    name: "submit",
    message: "Submit selected",
  },
  continueDisabled: {
    name: "continueDisabled",
    message: "Continue disabled",
  },
  submitDisabled: {
    name: "submitDisabled",
    message: "Submit disabled",
  },
  submitContinueDisabled: {
    name: "submitContinueDisabled",
    message: "Submit and Continue disabled",
  },
  submitContinue: {
    name: "submitContinue",
    message: "Submit and Continue selected",
  },
};
